import { Component, Input } from '@angular/core';
import { IRootState } from '@mnz-core/modules/store/models/root-state';
import { select, Store } from '@ngrx/store';
import * as appSelectors from '@mnz-store/selectors/app.selectors';
import * as appActions from '@mnz-store/actions/app.actions';
import { IMessage } from '@mnz-core/models/message';

@Component({
  selector: 'mnz-messageStoreConnector',
  templateUrl: './messageStoreConnector.component.html',
})
export class MessageStoreConnectorComponent {
  @Input('message-class') messageClass: string;

  constructor(private readonly _store$: Store<IRootState>) {}

  readonly messages$ = this._store$.pipe(select(appSelectors.getLatestNotifications));

  onCloseMessage({ id }: IMessage): void {
    this._store$.dispatch(appActions.deleteMessage({ id }));
  }
}
